import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import WalletList from "../SignInUp/components/walletList";
import { COMMON_WEB_PATH, CURRENCY_SYMBOL } from "../../constant";
import { IoIosAdd } from "react-icons/io";
import { useNavigate, useLocation } from "react-router";
import {
  AbsoluteCenter,
  Box,
  Divider,
  Flex,
  Icon,
  Image,
  Popover,
  PopoverTrigger,
  Text,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import useCheckLogin from "../../hook/useCheckLogin";
import BalanceContent from "./BalanceContent";

const isCredit = process.env.REACT_APP_CREDIT == 1;
const Balance = () => {
  const { isOpen, onToggle, onClose } = useDisclosure();
  const { isMachineUser } = useCheckLogin();

  const linkColor = useColorModeValue("light.100", "#394367");

  const memberInfo = useSelector((state) => state.isMemberInfo);

  const { pathname } = useLocation();

  return (
    <Popover
      variant={"brandPrimary"}
      isOpen={isOpen}
      onClose={onClose}
      placement="bottom"
    >
      <Flex
        px="10px"
        borderRadius={`20px`}
        // _hover={{
        //   bg: baseHoverBg,
        // }}
        // bg={baseBg}
        //bgImage={`url('${COMMON_WEB_PATH}/911TW/creditBG.webp')`}
        bgImage={{
          base: "none",
          md: `url('${COMMON_WEB_PATH}/911TW/creditBG.webp')`,
        }}
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="100%100%"
        pl={{
          base: "0px",
          md: "40px",
        }}
        pr={{
          base: "0px",
          md: "40px",
        }}
        pb={{
          base: "2px",
          md: "15px",
        }}
        pt={{
          base: "2px",
          md: "25px",
        }}
        alignItems="center"
        gap="10px"
        minW={{
          base: "100px",
          //md: "180px",
          md: isMachineUser ? "230px" : "180px",
        }}
        height={{
          base: "35px",
          sm: "65px",
          md: "90px",
          //xl: "90px",
          xl: isMachineUser ? "120px" : "90px",
        }}
        cursor="pointer"
        position="relative"
        // mb={{
        //   sm: "10px",
        // }}
        shadow="sm"
        justifyContent={"center"}
        border={{
          md: "none",
          base: "1px solid",
        }}
        borderColor={{
          md: "transparent",
          base: "#7E2BD0",
        }}
      >
        <AbsoluteCenter
          display={{
            base: "none",
            md: "block",
          }}
          //w="90px"
          w={isMachineUser ? "120px" : "90px"}
          //top="18px"
          top={isMachineUser ? "25px" : "18px"}
        >
          <Image src={`${COMMON_WEB_PATH}/911TW/creditTitle.webp`} />
        </AbsoluteCenter>
        <Flex w="100%" direction={`column`} alignItems={`center`}>
          {/* <Text
              display={{
                base: "block",
                md: "none",
              }}
              fontSize="sm"
            >
              {memberInfo?.memId}
            </Text> */}
          <Divider
            display={{
              base: "block",
              md: "none",
            }}
            w="100%"
          />
          <Box
            onClick={() => {
              if (pathname.includes("gamebox")) {
                return;
              } else {
                if (isCredit) {
                  return;
                }
                onToggle();
              }
            }}
            display={`flex`}
            alignItems={`center`}
            gap="5px"
          >
            <BalanceContent
              // hiddenSymbol
              hiddenSymbol={window.innerWidth >= 768} // 768px寬度以上不顯示符號
              balanceStyle={{
                fontSize: {
                  base: "18px",
                  md: "20px",
                  lg: "24px",
                  xl: "28px",
                },
                fontWeight: "900",
              }}
            />
          </Box>
        </Flex>
      </Flex>
      {/* <WalletList onClose={onClose} /> */}
    </Popover>
  );
};

export default Balance;
